import ScrollToTop from "react-scroll-to-top";
import { TbArrowBigUpLinesFilled } from "react-icons/tb";
import "./ScrollToTop.scss";

const ScrollButton = () => {
  return (
    <ScrollToTop
      smooth
      top={300} // shows after 300px scroll
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 99,
      }}
      className="scroll-to-top-btn"
      component={<TbArrowBigUpLinesFilled size={25} />}
    />
  );
};

export default ScrollButton;
